import React from "react";
import { cn } from "@/lib/utils";

/**
 * Reusable section heading used across the v0-inspired landing sections.
 */
export function SectionHeading({
  eyebrow,
  title,
  description,
  className,
  align = "center",
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4",
        align === "center"
          ? "items-center text-center"
          : "items-start text-left",
        className,
      )}
    >
      {eyebrow && (
        <span className="inline-flex items-center rounded-full bg-brand/10 px-5 py-2 text-sm font-medium uppercase tracking-[0.18em] text-brand">
          {eyebrow}
        </span>
      )}
      <h2 className="max-w-2xl text-balance font-heading text-3xl leading-[1.1] tracking-tight text-foreground sm:text-4xl md:text-5xl">
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            "max-w-2xl text-pretty text-base leading-relaxed text-muted-foreground sm:text-lg",
            align === "center" && "mx-auto",
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
}

export default SectionHeading;
